import React, { Component } from 'react';

import '../../css/spinner.css';

import { SelectableCard } from './SelectableCard';
import { LicenseKeyList } from './LicenseKeyList';

export class LicenseKey extends Component {
    displayName = LicenseKey.name;

    constructor(props) {
        super(props);

        this.state = {
            licenseKey: ''
        };
    }

    componentDidMount() {
        this.setState({ loading: this.props.productKeys.length });
    }

    updateLicenseKey = (event) => {
        this.setState({ licenseKey: event.target.value });
    }

    addKey = () => {
        const { addKey, loadingLicense, setLoading } = this.props;
        let key = this.state.licenseKey.trim();
        if (key === '') {
            // Nothing was submitted, so the loading counter must not
            // move or the spinner never stops.
            this.setState({ emptyKey: true });
            return;
        }
        this.setState({ licenseKey: '', emptyKey: false });
        addKey(key);
        setLoading(loadingLicense + 1);
    }

    render() {
        var vendors = this.props.requiredVendors;

        return (
            <SelectableCard
                id={this.props.id}
                selected={this.props.selected}
                disabled={this.props.disabled}
                onSelected={this.props.onSelected}>
                <div className="b-form-group b-form-group--with-icon">
                    <img src={this.props.fiftyone ? this.props.fiftyone.iconUrl : '/images/icon-feature-vendor-51d.png'} className="b-icon" alt="51Degrees" />
                    <div className="b-input-group">
                        <input type="text" className="b-input b-input--block" id="input" placeholder={`Enter your 51Degrees license key`} onChange={this.updateLicenseKey} value={this.state.licenseKey} disabled={this.props.disabled} />
                        <button className="b-btn" onClick={this.addKey} disabled={this.props.disabled}>Add&nbsp;Key</button>
                        <a className="b-btn b-btn--secondary" href="https://51degrees.com/pricing" target="_blank" rel="noopener noreferrer">View&nbsp;plans</a>
                    </div>
                    {this.state.emptyKey ? (
                        <p className="c-license-key__error" role="alert">
                            Enter a License Key before clicking Add Key.
                        </p>
                    ) : null}
                    <p className="g-info__description c-license-key__hint">
                        Add each License Key you hold. Some selections need
                        more than one, for example your base Cloud key and
                        your 51Did key.
                    </p>
                    {vendors.length > 0 ? (
                        <div className="c-required-keys">
                            <p className="c-required-keys__title">
                                License keys required for:
                            </p>
                            <ul className="c-required-keys__list">
                                {vendors.map((v, i) => (
                                    <li key={i} className={`c-required-keys__item ${
                                        v.available ? 'is-provided' : ''}`}>
                                        <span className="c-required-keys__mark"
                                            aria-hidden="true">
                                            {v.available ? '✓' : '•'}
                                        </span>
                                        <span className="c-required-keys__name">
                                            {v.name}
                                        </span>
                                        {v.available ? (
                                            <span className="c-required-keys__done">
                                                {' '}provided
                                            </span>
                                        ) : null}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ) : null}
                </div>
                <LicenseKeyList
                    productKeys={this.props.productKeys}
                />
                {this.props.loadingLicense > this.props.productKeys.length ? <div className="icon-container">
                    <i className="loader"></i>
                </div> : null}
            </SelectableCard>
        );
    }
}
